/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SourceSurveyItemDto,
    SourceSurveyItemDtoFromJSON,
    SourceSurveyItemDtoFromJSONTyped,
    SourceSurveyItemDtoToJSON,
} from './SourceSurveyItemDto';

/**
 * 
 * @export
 * @interface AdminAcquisitionDto
 */
export interface AdminAcquisitionDto {
    /**
     * Total number of registered users
     * @type {number}
     * @memberof AdminAcquisitionDto
     */
    totalUsers: number;
    /**
     * User breakdown by source survey
     * @type {Array<SourceSurveyItemDto>}
     * @memberof AdminAcquisitionDto
     */
    sourceSurveyBreakdown: Array<SourceSurveyItemDto>;
    /**
     * Number of users without source survey data
     * @type {number}
     * @memberof AdminAcquisitionDto
     */
    usersWithoutSurvey: number;
    /**
     * Percentage of users with verified email (isEmailVerified = true)
     * @type {number}
     * @memberof AdminAcquisitionDto
     */
    emailVerificationRate: number;
    /**
     * Percentage of users with activation date (activationDate != null)
     * @type {number}
     * @memberof AdminAcquisitionDto
     */
    activationRate: number;
    /**
     * Number of users with verified email
     * @type {number}
     * @memberof AdminAcquisitionDto
     */
    verifiedUsersCount: number;
    /**
     * Number of users with activation date
     * @type {number}
     * @memberof AdminAcquisitionDto
     */
    activatedUsersCount: number;
}

export function AdminAcquisitionDtoFromJSON(json: any): AdminAcquisitionDto {
    return AdminAcquisitionDtoFromJSONTyped(json, false);
}

export function AdminAcquisitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAcquisitionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalUsers': json['totalUsers'],
        'sourceSurveyBreakdown': ((json['sourceSurveyBreakdown'] as Array<any>).map(SourceSurveyItemDtoFromJSON)),
        'usersWithoutSurvey': json['usersWithoutSurvey'],
        'emailVerificationRate': json['emailVerificationRate'],
        'activationRate': json['activationRate'],
        'verifiedUsersCount': json['verifiedUsersCount'],
        'activatedUsersCount': json['activatedUsersCount'],
    };
}

export function AdminAcquisitionDtoToJSON(value?: AdminAcquisitionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalUsers': value.totalUsers,
        'sourceSurveyBreakdown': ((value.sourceSurveyBreakdown as Array<any>).map(SourceSurveyItemDtoToJSON)),
        'usersWithoutSurvey': value.usersWithoutSurvey,
        'emailVerificationRate': value.emailVerificationRate,
        'activationRate': value.activationRate,
        'verifiedUsersCount': value.verifiedUsersCount,
        'activatedUsersCount': value.activatedUsersCount,
    };
}

